export const firebaseConfig = {
  apiKey: "AIzaSyDChq_tDI936uUYMSnrqCuAso5I85JC55c",
  authDomain: "vkleykakz.firebaseapp.com",
  projectId: "vkleykakz",
  storageBucket: "vkleykakz.appspot.com",
  messagingSenderId: "586834879283",
  appId: "1:586834879283:web:ec622f286ccc7f3fb5d446",
  measurementId: "G-J8DQLMKF5G"
};